"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tab = exports.tab = 9;
var enter = exports.enter = 13;
var escape = exports.escape = 27;
var space = exports.space = 32;
var arrowLeft = exports.arrowLeft = 37;
var arrowUp = exports.arrowUp = 38;
var arrowRight = exports.arrowRight = 39;
var arrowDown = exports.arrowDown = 40;


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/key-codes.js
// module id = 484
// module chunks = 0